export default __webpack_public_path__ + "static/media/guide_03_01.6a2a6868.png";